import PeerGroups from "../components/PeerGroup/PeerGroups";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All, KeyValue } from "../interfaces";
import { updateUi } from "../common/actions";

function mapStateToProps({ appState }: All) {
  return {
    appState: appState.peerGroup,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updatePGCStep: (pgcStep: string) => {
      dispatch(updateUi("pgcStep", pgcStep));
      dispatch(actions.searchPush());
    },
    updatePeerGroups: (peerGroups: string[]) => {
      dispatch(updateUi("peerGroups", peerGroups));
      dispatch(actions.searchPush());
    },
    updatePeerGroupNames: (groupNames: string[]) => {
      dispatch(updateUi("peerGroupNames", groupNames));
      dispatch(actions.searchPush());
    },
    updateUi: (uiField: string, uiValue: KeyValue[] | string) => {
      dispatch(actions.updateUi(uiField, uiValue));
      dispatch(actions.searchPush());
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(PeerGroups);
